<app-mobility-legend-widget
  *ngIf="showLegend"
  [colors]="legendColors"
  [labels]="_stats && _stats.legend"
  [type]="legendType"
  [title]="getLegendTitle()"
  [titleExtra]="getLegendExtra()"
  [subtitle]="getLegendSubtitle() | translate"
  [showDensity]="isDensityAvailable()"
>
</app-mobility-legend-widget>
<ng-content></ng-content>
<app-pie-chart-widget
  class="gender"
  *ngIf="canShowTargetWidget('gender')"
  title="{{ 'Gender distribution' | translate }} (%)"
  [data]="getTargetWidgetData('gender')"
  [unit]="keyIndicatorLabel.toLowerCase() | translate"
  [labels]="compareLabels"
  [isMultiple]="compareMode"
  [colors]="[colorMen, colorWomen]"
  icon="/assets/img/icons/color/{{ genderIcon }}.svg"
  [highlight]="getWidgetValue('gender')"
  [stats]="stats.visitors"
>
</app-pie-chart-widget>
<app-pyramid-widget
  class="age"
  *ngIf="canShowTargetWidget('age')"
  title="{{ 'Population distribution' | translate }} (%)"
  description="{{ '% by Age ranges, both genders' | translate }}"
  [unit]="keyIndicatorLabel.toLowerCase() | translate"
  [data]="getTargetWidgetData('age')"
  [labels]="compareLabels"
  [isMultiple]="compareMode"
  [highlight]="getWidgetValue('age')"
  [stats]="stats.visitors"
>
</app-pyramid-widget>

<app-stats-widget
  *ngFor="let stat of variableWidgets"
  [stats]="[stat]"
  [isMultiple]="compareMode"
></app-stats-widget>

<app-stats-widget
  *ngIf="getTooltipWidgetData().length !== 0"
  [stats]="getTooltipWidgetData()"
  [isMultiple]="compareMode"
></app-stats-widget>

<ng-container *ngFor="let widget of targetWidgets">
  <app-bar-chart-widget
    class="type"
    *ngIf="widget.label && canShowTargetWidget(widget.id)"
    [title]="widget.label | translate"
    [data]="getTargetWidgetData(widget.id)"
    [unit]="getTargetWidgetUnit(widget.id) | translate"
    [isMultiple]="compareMode"
    [tooltipSuffix]="keyIndicatorLabel.toLowerCase() | translate"
    [highlight]="getWidgetValue(widget.id)"
    [stats]="stats.visitors"
  >
  </app-bar-chart-widget>
</ng-container>

<app-bars-widget
  class="type lowercase"
  *ngIf="canShowTargetWidget('duration')"
  title="{{ 'Number of visits by duration (min)' | translate }}"
  [data]="getTargetWidgetData('duration')"
  [unit]="getTargetWidgetUnit('duration') | translate"
  [isMultiple]="compareMode"
  [highlight]="getWidgetValue('duration')"
  [stats]="stats.visitors"
>
</app-bars-widget>

<app-bars-widget
  class="type"
  *ngIf="canShowTargetWidget('visitor_profile')"
  title="{{
    'Number of ' +
      keyIndicatorLabel.toLowerCase() +
      ' by' +
      (keyIndicator === 'nvisits' ? ' visitors' : '') +
      ' type' | translate
  }}"
  [data]="getTargetWidgetData('visitor_profile')"
  [unit]="getTargetWidgetUnit('visitor_profile') | translate"
  [isMultiple]="compareMode"
  [highlight]="getWidgetValue('visitor_profile')"
  [stats]="stats.visitors"
>
</app-bars-widget>

<app-bars-widget
  class="economy"
  *ngIf="canShowTargetWidget('economy')"
  title="{{ 'Economy' | translate }}"
  [data]="getTargetWidgetData('economy')"
  [unit]="getTargetWidgetUnit('economy') | translate"
  [isMultiple]="compareMode"
  [highlight]="getWidgetValue('economy')"
  [stats]="stats.visitors"
>
</app-bars-widget>

<app-bars-widget
  class="economy"
  *ngIf="canShowTargetWidget('economic_status')"
  title="{{ 'Economy' | translate }}"
  [unit]="getTargetWidgetUnit('economic_status') | translate"
  [data]="getTargetWidgetData('economic_status')"
  [isMultiple]="compareMode"
  [highlight]="getWidgetValue('economic_status')"
  [stats]="stats.visitors"
>
</app-bars-widget>
<app-bars-widget
  class="wealth"
  *ngIf="canShowTargetWidget('direction_of_travel')"
  title="{{ 'Direction of travel' | translate }}"
  [unit]="getTargetWidgetUnit('direction_of_travel') | translate"
  [data]="getTargetWidgetData('direction_of_travel')"
  [isMultiple]="compareMode"
  [highlight]="getWidgetValue('direction_of_travel')"
  [stats]="stats.visitors"
>
</app-bars-widget>

<app-bars-widget
  class="mode-transports"
  *ngIf="canShowTargetWidget('mode_of_transport')"
  title="{{ 'Mode of transports' | translate }}"
  [unit]="getTargetWidgetUnit('mode_of_transport') | translate"
  [data]="getTargetWidgetData('mode_of_transport')"
  [isMultiple]="compareMode"
  [highlight]="getWidgetValue('mode_of_transport')"
  [stats]="stats.visitors"
>
</app-bars-widget>

<app-bars-widget
  class="wealth"
  *ngIf="canShowTargetWidget('wealth')"
  title="{{ 'Levels by wealth' | translate }}"
  [unit]="getTargetWidgetUnit('wealth') | translate"
  [data]="getTargetWidgetData('wealth')"
  [isMultiple]="compareMode"
  [highlight]="getWidgetValue('wealth')"
  [stats]="stats.visitors"
>
</app-bars-widget>

<app-bar-chart-widget
  class="type"
  *ngIf="canShowTargetWidget('overnightstays_distribution')"
  title="{{ 'Tourists overnightstays' | translate }} (%)"
  [data]="getTargetWidgetData('overnightstays_distribution')"
  [unit]="getTargetWidgetUnit('overnightstays_distribution') | translate"
  [isMultiple]="compareMode"
  [tooltipSuffix]="keyIndicatorLabel.toLowerCase() | translate"
  [highlight]="getWidgetValue('overnightstays_distribution')"
  [stats]="stats.visitors"
  [usePerc]="true"
>
</app-bar-chart-widget>

<app-bars-widget
  *ngIf="canShowTargetWidget('visitor_tourism_profile_tripper')"
  title="{{ 'Tripper' | translate }}"
  [data]="getTargetWidgetData('visitor_tourism_profile_tripper')"
  [isMultiple]="compareMode"
  [unit]="getTargetWidgetUnit('visitor_tourism_profile_tripper') | translate"
  [stats]="stats.visitors"
>
</app-bars-widget>

<app-bars-widget
  *ngIf="canShowTargetWidget('visitor_tourism_profile_tourist')"
  title="{{ 'Tourist' | translate }}"
  [data]="getTargetWidgetData('visitor_tourism_profile_tourist')"
  [isMultiple]="compareMode"
  [unit]="getTargetWidgetUnit('visitor_tourism_profile_tourist') | translate"
  [stats]="stats.visitors"
>
</app-bars-widget>

<app-bars-widget
  class="tripSummary"
  *ngIf="canShowTripSummary()"
  title="{{ keyIndicatorLabel + ' from' | translate }}..."
  [data]="getWidgetData('tripsSummary')"
  [isMultiple]="compareMode"
  [unit]="getWidgetUnit('tripsSummary') | translate"
  [stats]="stats.visitors"
>
</app-bars-widget>
<app-list-widget
  class="ranking"
  *ngIf="canShowStatsWidget('ranking')"
  [title]="getWidgetTitle('neighbourhood')"
  [data]="getWidgetData('ranking')"
  [labels]="compareLabels"
  [unit]="getWidgetUnit('ranking') | translate"
  [isMultiple]="compareMode"
  [stats]="stats.visitors"
>
</app-list-widget>
<app-list-widget
  class="tripsLocal"
  *ngIf="canShowStatsWidget('tripsLocal')"
  [title]="getWidgetTitle('region_local')"
  [data]="getWidgetData('tripsLocal')"
  [unit]="getWidgetUnit('tripsLocal') | translate"
  [labels]="compareLabels"
  [isMultiple]="compareMode"
  [stats]="stats.visitors"
>
</app-list-widget>
<app-list-widget
  class="tripsBorough"
  *ngIf="canShowStatsWidget('tripsBorough')"
  [title]="getWidgetTitle('sub_local_alternative')"
  [data]="getWidgetData('tripsBorough')"
  [unit]="getWidgetUnit('tripsBorough') | translate"
  [labels]="compareLabels"
  [isMultiple]="compareMode"
  [stats]="stats.visitors"
>
</app-list-widget>
<app-list-widget
  class="tripsNational"
  *ngIf="canShowStatsWidget('tripsNational')"
  [title]="getWidgetTitle('region_small')"
  [data]="getWidgetData('tripsNational')"
  [unit]="getWidgetUnit('tripsNational') | translate"
  [labels]="compareLabels"
  [isMultiple]="compareMode"
  [stats]="stats.visitors"
>
</app-list-widget>
<app-list-widget
  class="tripsInternational"
  *ngIf="canShowStatsWidget('tripsInternational')"
  [title]="getWidgetTitle('country')"
  [data]="getWidgetData('tripsInternational')"
  [unit]="getWidgetUnit('tripsInternational') | translate"
  [labels]="compareLabels"
  [isMultiple]="compareMode"
  [stats]="stats.visitors"
>
</app-list-widget>
<div style="width: 2px; height: 72px"></div>
